module.exports = __webpack_public_path__ + "static/media/arrow-collapse-gray.e1aabb86.svg";